import React from 'react';
import {connect} from 'react-redux';
import compose from 'recompose/compose';
import setDisplayName from 'recompose/setDisplayName';
import ImageRecropModal from 'components/images/ImageRecropModal';
import {closeNativeRecropModalAction, nativeUploadImageAction} from './actions';
import {fetchRemoteImage} from 'api/images';
import {isNoU} from 'utils/DBUtils';

/*
    Mounted once, at the page level (see pages/EditBreak/EditBreakPage.jsx), alongside
    ImageUploadModalContainer/ImageEditModalContainer. hoc/BreakImagePicker.jsx's editImage
    handler opens this for any image field's Edit Image action by dispatching
    openNativeRecropModalAction with that field's resource-hierarchy context plus the
    image's originalImageId; that context is read back here (state.images.nativeRecropContext)
    so onConfirm can attach the recropped result to the right field.

    onConfirm dispatches the exact same nativeUploadImageAction the upload flow (§4) does --
    with preCropped: true and no mediaUrl, since a recrop always produces a cropped file --
    so it's handled by the same, unmodified nativeUploadImageEpic and writes to the field
    through the same saveResourceFieldAction tail. No new Redux plumbing beyond this
    open/close bridge was needed.
*/
const mapStateToProps = (state) => {
    const context = state.images.nativeRecropContext;
    return {
        isOpen: !isNoU(context),
        imageType: context ? context.imageType : '',
        originalImageId: context ? context.originalImageId : '',
        context
    };
};

const mapDispatchToProps = (dispatch) => ({dispatch});

const mergeProps = (stateProps, dispatchProps) => ({
    imageType: stateProps.imageType,
    originalImageId: stateProps.originalImageId,
    isOpen: stateProps.isOpen,
    fetchRemoteImage,
    onCancel: () => dispatchProps.dispatch(closeNativeRecropModalAction()),
    onConfirm: (upload) => {
        const {context} = stateProps;
        if (isNoU(context)) {
            return;
        }
        dispatchProps.dispatch(nativeUploadImageAction(
            context.imageType,
            context.rootResource,
            context.forResourceId,
            context.resourcePath,
            context.fieldPath,
            context.field,
            context.parentIds,
            upload
        ));
    }
});

export default compose(
    setDisplayName('ImageRecropModalContainer'),
    connect(mapStateToProps, mapDispatchToProps, mergeProps)
)(ImageRecropModal);



// WEBPACK FOOTER //
// ./public/pages/Images/ImageRecropModalContainer.jsx